import React, {useState} from "react";
import useAuth from "../hooks/useAuth";
import {resetMenu} from "../redux/slices/menuSlice";
import {useDispatch} from "react-redux";
import {Table, Space, Pagination, DatePicker, Badge, Modal, notification, Input as InputAntd} from 'antd';
import EntityApi from "../api/EntityApi";
import { SearchOutlined } from '@ant-design/icons';
import Input from "../components/element/Input";
import Button from "../components/element/Button";
import dayjs from "dayjs";
import RequestApi from "../api/RequestApi";
import config from "../api/config";
import {Link, useNavigate} from "react-router-dom";
const OrdersPage = () => {

    const { roles }  = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [apiNotification, contextHolder] = notification.useNotification();
    const [dataSource, setDataSource] = useState([]);
    const [expandDataSource, setExpandDataSource] = useState([]);
    const [sortField, setSortField] = useState('dt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [isLoading, setIsLoading] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    const [filter, setFilter] = useState({});

    const [inputId, setInputId] = useState('');
    const [inputPriceFrom, setInputPriceFrom] = useState('');
    const [inputPriceTo, setInputPriceTo] = useState('');
    const [inputClient, setInputClient] = useState('');
    const [inputDateFrom, setInputDateFrom] = useState('');
    const [inputDateTo, setInputDateTo] = useState('');
    const [inputDatePaymentFrom, setInputDatePaymentFrom] = useState('');
    const [inputDatePaymentTo, setInputDatePaymentTo] = useState('');
    const [inputIsNotPayment, setInputIsNotPayment] = useState(false);

    const [isOpenPayment, setOpenPayment] = React.useState(false);
    const [orderPayment, setOrderPayment ] = React.useState(0);
    const [inputDatePayment, setInputDatePayment ] = React.useState('');
    const [inputCommentPayment, setInputCommentPayment ] = React.useState('');

    const handleResetField = (field, confirm) => {
        confirm();
        let newFilter = filter;
        if (field === 'price') {
            setInputPriceFrom('');
            setInputPriceTo('');
            newFilter.price = '';
        }
        if (field === 'id') {
            setInputId('');
            newFilter.id = 0;
        }
        if (field === 'client') {
            setInputClient('');
            newFilter.client = '';
        }
        if (field === 'dt') {
            setInputDateFrom('');
            setInputDateTo('');
            newFilter.dt = '';
        }
        if (field === 'payment') {
            setInputDatePaymentFrom('');
            setInputDatePaymentTo('');
            setInputIsNotPayment(false);
            newFilter.payment_dt = '';
            newFilter.is_not_payment = '';
        }
        setFilter(newFilter);
        setIsReload(!isReload);
    }

    const handleReset = () => {
        setInputPriceFrom('');
        setInputPriceTo('');
        setInputId('');
        setInputClient('');
        setInputDateFrom('');
        setInputDateTo('');
        setInputDatePaymentFrom('');
        setInputDatePaymentTo('');
        setInputIsNotPayment(false);
        setFilter({});
        setIsReload(!isReload);
    }

    const applyFilter = () => {
        let newFilter = filter;
        newFilter.price = [inputPriceFrom, inputPriceTo];
        newFilter.id = inputId;
        newFilter.client = inputClient;
        newFilter.dt = [inputDateFrom, inputDateTo];
        newFilter.payment_dt = [inputDatePaymentFrom, inputDatePaymentTo];
        newFilter.is_not_payment = inputIsNotPayment;
        setFilter(newFilter);
    }

    const handleSearch = (field, confirm) => {
        confirm();
        applyFilter();
        setIsReload(!isReload);
    }

    const RenderSearchFooter = ({field, confirm}) => {
        return <Space className={'p-2'}>
            <Button text={'Найти'} type={'primary'} onClick={() => confirm && handleSearch(field, confirm)}/>
            <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetField(field, confirm)}/>
        </Space>
    }

    const getColumnSearch = (field) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            if (field === 'price') {
                return <><div className={'flex p-2'}>
                    <Input type={'text'} value={inputPriceFrom} placeholder={'от'} onChange={(value)=> setInputPriceFrom(value)}/>
                    <div className={'pl-4'}>
                        <Input type={'text'} value={inputPriceTo} placeholder={'от'} onChange={(value)=> setInputPriceTo(value)}/>
                    </div>
                </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'id') {
                return <>
                    <div className={'flex p-2'}>
                        <Input isFullWidth={true} type={'text'} value={inputId} placeholder={'Номер заказа'} onChange={(value)=> setInputId(value)}/>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'client') {
                return <>
                    <div className={'flex p-2'} style={{width: '300px'}}>
                        <Input isFullWidth={true} type={'text'} value={inputClient} placeholder={'Номер телефона или имя'} onChange={(value)=> setInputClient(value)}/>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'dt') {
                return <>
                    <div className={'flex p-2'}>
                        <DatePicker value={inputDateFrom ? dayjs(inputDateFrom, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setInputDateFrom(dateString)} placeholder={'от'} format={'DD.MM.YYYY'}/>
                        <div className={'pl-4'}>
                            <DatePicker value={inputDateTo ? dayjs(inputDateTo, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setInputDateTo(dateString)} placeholder={'до'} format={'DD.MM.YYYY'}/>
                        </div>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'payment') {
                return <>
                    <div className={'p-2'}>
                        <label className={'flex cursor-pointer'}>
                            <input type={'checkbox'} checked={inputIsNotPayment} onChange={e => setInputIsNotPayment(e.target.checked)}/>
                            <div className={'pl-4'}>Без оплаты</div>
                        </label>
                        <div className={'flex pt-2'}>
                            <DatePicker value={inputDatePaymentFrom ? dayjs(inputDatePaymentFrom, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setInputDatePaymentFrom(dateString)} placeholder={'от'} format={'DD.MM.YYYY'}/>
                            <div className={'pl-4'}>
                                <DatePicker value={inputDatePaymentTo ? dayjs(inputDatePaymentTo, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setInputDatePaymentTo(dateString)} placeholder={'до'} format={'DD.MM.YYYY'}/>
                            </div>
                        </div>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
        },
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )

    })

    const columns = [];
    columns.push({
        title: 'Информация о заказе',
        responsive: ['xs'],
        ...getColumnSearch('id'),
        render: (item) => {
            return <>
                <div>Заказ #{item.id} от {item.dt}</div>
                {(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) &&
                    <div>
                        <div><span className={'font-bold'}>ФИО:</span> <Link
                            to={'/cabinet/users/' + item.clientId}>{item.client}</Link></div>
                        <div><span className={'font-bold'}>Телефон:</span> <Link
                            to={'/cabinet/users/' + item.clientId}>{item.login}</Link></div>
                        <div><span className={'font-bold'}>Организация:</span> {item.company}</div>
                    </div>
                }
                <div><span className={'font-bold'}>Сумма:</span> {item.price}</div>
                <div>
                    {
                        item.is_payment && <><Badge status="success" text={'Оплачено'}/>
                            <div>{item.payment_dt}</div>
                        </>
                    }
                    {
                        !item.is_payment && <Badge status="error" text={'Не оплачено'}/>
                    }
                    {
                        item.is_payment && item.payment_data.comment !== undefined &&
                        <span className={"text-xs"} style={{color: 'grey'}}>{item.payment_data.comment}</span>
                    }
                    {
                        item.is_payment && item.payment_data.comment === undefined &&
                        <span className={"text-xs"} style={{color: 'grey'}}>Картой</span>
                    }
                </div>
                <div className={'mt-2'}>
                    {
                        !roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_MANAGER') && !roles.includes('ROLE_PARTNER') && !item.is_payment && !item.is_cancelled &&
                        <div className={'pb-2'}>
                            <Button onClick={() => onPaymentProcess(item.id)} text={'Оплатить картой'}
                                    type={'successSmall'}/>
                            <div className={'pt-2'}>
                                <Button onClick={() => onPaymentInvoiceProcess(item.id)} text={'Оплатить по счету'}
                                        type={'successSmall'}/>
                            </div>
                        </div>
                    }
                    {
                        (((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) || !item.is_payment) && !item.is_cancelled) &&
                        <div className={'pb-2'}><Button onClick={() => onCancelOrder(item.id)} text={'Отменить'}
                                                        type={'warningSmall'}/></div>
                    }
                    {
                        (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && item.is_payment &&
                        <div className={'pb-2'}><Button onClick={() => onCancelPayment(item.id)} text={'Снять оплату'}
                                                        type={'defaultSmall'}/></div>
                    }
                    {
                        ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && !item.is_payment) && !item.is_cancelled &&
                        <div className={'pb-2'}><Button onClick={() => onSetPayment(item.id)} text={'Установить оплату'}
                                                        type={'successSmall'}/></div>
                    }
                    {
                        item.is_cancelled && <Badge status={'error'} text={'Заказ отменен'}/>
                    }
                </div>
            </>
        }
        //width: 100,
        //dataIndex: 'id',
        //sorter: true,
        //...getColumnSearch('id')
    });
    columns.push({
        title: 'Номер',
        width: 100,
        dataIndex: 'id',
        sorter: true,
        responsive: ['md'],
        ...getColumnSearch('id')
    });
    columns.push({
        title: 'Дата',
        width: 150,
        dataIndex: 'dt',
        sorter: true,
        responsive: ['md'],
        ...getColumnSearch('dt')
    });
    if (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) {
        columns.push({
            title: 'ФИО',
            //width: 300,
            dataIndex: 'client',
            responsive: ['md'],
            ...getColumnSearch('client'),
            render: (client, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.client}</Link>
        });
        columns.push({
            title: 'Номер телефона',
            //width: 300,
            dataIndex: 'login',
            responsive: ['md'],
            ...getColumnSearch('client'),
            render: (client, data) => <Link to={'/cabinet/users/' + data.clientId}>{data.login}</Link>
        });
        columns.push({
            title: 'Организация',
            responsive: ['md'],
            //width: 300,
            dataIndex: 'company'
        });
    }
    columns.push({
        title: 'Сумма',
        width: roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') ? 150 : 'auto',
        align: 'right',
        dataIndex: 'price',
        responsive: ['md'],
        sorter: true,
        ...getColumnSearch('price')
    });
    columns.push({
        title: 'Оплата',
        width: 200,
        //dataIndex: 'payment',
        responsive: ['md'],
        ...getColumnSearch('payment'),
        render: (item) => <>
            {
                item.is_payment && <><Badge status="success" text={'Оплачено'} /><div>{item.payment_dt}</div></>
            }
            {
                !item.is_payment && <Badge status="error" text={'Не оплачено'} />
            }
            {
                item.is_payment && item.payment_data.comment !== undefined && <span className={"text-xs"} style={{color: 'grey'}}>{item.payment_data.comment}</span>
            }
            {
                item.is_payment && item.payment_data.comment === undefined && <span className={"text-xs"} style={{color: 'grey'}}>Картой</span>
            }
        </>
    });
    columns.push({
        width: 200,
        responsive: ['md'],
        render: (item) => <div className={''}>
            {
                !roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_MANAGER') && !roles.includes('ROLE_PARTNER') && !item.is_payment && !item.is_cancelled  &&
                <div className={'pb-2'}>
                    <Button onClick={() => onPaymentProcess(item.id)} text={'Оплатить картой'} type={'successSmall'}/>
                    <div className={'pt-2'}>
                        <Button onClick={() => onPaymentInvoiceProcess(item.id)} text={'Оплатить по счету'} type={'successSmall'}/>
                    </div>
                </div>
            }
            {
                (((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) || !item.is_payment) && !item.is_cancelled)  &&
                <div className={'pb-2'}><Button onClick={() => onCancelOrder(item.id)} text={'Отменить'} type={'warningSmall'}/></div>
            }
            {
                (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && item.is_payment  &&
                <div className={'pb-2'}><Button onClick={() => onCancelPayment(item.id)} text={'Снять оплату'} type={'defaultSmall'}/></div>
            }
            {
                ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && !item.is_payment) && !item.is_cancelled  &&
                <div className={'pb-2'}><Button onClick={() => onSetPayment(item.id)} text={'Установить оплату'} type={'successSmall'}/></div>
            }
            {
                item.is_cancelled && <Badge status={'error'} text={'Заказ отменен'}/>
            }

        </div>
    });

    const expandColumns = [
        {
            title: 'Список курсов',
            responsive: ['xs'],
            render: (item) => {
                return <>
                    <div><span className={'font-bold'}>Код: </span>{item.entity_code}</div>
                    <div>{item.name}</div>
                    <div>{item.quantity} шт x {item.price} = {item.quantity * item.price} руб.</div>
                    <div><span className={'font-bold'}>Доступ: </span>{item.access_text}</div>
                    {
                        item.consumers &&
                        <>
                            {
                                item.consumers.map((item, index) =>
                                    <div className={'text-xs'}>{index + 1}. {item.surname} {item.name}: {item.phone} {
                                        item.email && <span>/ {item.email}</span>
                                    }</div>
                                )
                            }
                        </>
                    }
                </>
            }
        },
        {
            title: 'Код',
            width: 150,
            responsive: ['md'],
            dataIndex: 'entity_code',
        },
        {
            title: 'Название',
            dataIndex: 'name',
            responsive: ['md'],
            render: (name, item) => <>
                {name}
                {
                    item.consumers &&
                    <>
                        {
                            item.consumers.map((item, index) =>
                                <div className={'text-xs'}>{index+1}. {item.surname} {item.name}: {item.phone} {
                                    item.email && <span>/ {item.email}</span>
                                }</div>
                            )
                        }
                    </>
                }
            </>
        },
        {
            title: 'Цена',
            width: 130,
            responsive: ['md'],
            dataIndex: 'price',
        },
        {
            title: 'Кол-во',
            width: 100,
            responsive: ['md'],
            dataIndex: 'quantity',
        },
        {
            title: 'Сумма',
            width: 120,
            responsive: ['md'],
            render: (item) => <>
                {item.quantity * item.price}
            </>
        },
        {
            title: 'Доступ',
            responsive: ['md'],
            width: 200,
            dataIndex: 'access_text',
        }
    ]

    const expandedRowRender = (data) => {
        return <Table columns={expandColumns} dataSource={expandDataSource[data.id]} pagination={false} />
    }

    const getList = () => {
        setIsLoading(true);
        EntityApi.getBy('private/order', {
            filter: filter,
            sort: {
                [sortField]: sortOrder
            },
            size: pageSize,
            page: page
        }).then((data) => {
            setIsLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                let items = [];
                let expandItems = {};
                if (data.content.items) {
                    data.content.items.forEach((order) => {
                        let item = {
                            key: order.id,
                            id: order.id,
                            dt: order.dt,
                            clientId:  order.client.id,
                            login:  order.client.login,
                            company:  order.client.company,
                            client: order.client.surname + ' ' +  order.client.name + ' ' + order.client.fathername,
                            price: order.price + ' руб.',
                            is_payment: order.is_payment,
                            payment_dt: order.payment_dt,
                            payment_data: order.payment_data,
                            is_cancelled: order.is_cancelled
                        }
                        items.push(item);
                        order.cart.forEach((cart) => {
                            if (!expandItems[order.id]) {
                                expandItems[order.id] = [];
                            }
                            cart.key = cart.id;
                            expandItems[order.id].push(cart);
                        })
                    });
                }
                setDataSource(items);
                setExpandDataSource(expandItems);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    React.useEffect(() => {
        dispatch(resetMenu());
        applyFilter();
        getList();
    }, [isReload])

    React.useEffect(() => {
        if (inputDatePaymentFrom !== '' || inputDatePaymentTo !== '') {
            setInputIsNotPayment(false);
        }
    }, [inputDatePaymentFrom, inputDatePaymentTo]);

    React.useEffect(() => {
        if (inputIsNotPayment) {
            setInputDatePaymentFrom('');
            setInputDatePaymentTo('');
        }
    }, [inputIsNotPayment])


    // events orders
    const onCancelPayment = (orderId) => {
        Modal.confirm({
            title: 'Подтвердите отмену оплаты',
            content: 'Вы действительно хотите отменить оплату? Если оплату отменить, то все доступы по заказу будут удалены.',
            footer: (_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'pr-2'}>
                        <Button text={'Отмена'} onClick={() => {Modal.destroyAll()}}/>
                    </div>
                    <Button text={'Подтверждаю'} onClick={() => onCancelPaymentConfirm(orderId)} type={'primary'}/>
                </div>
            ),
        });
    }

    const onCancelPaymentConfirm = (orderId) => {
        RequestApi.get('private/order/' + orderId + '/cancel-payment').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setIsReload(!isReload);
                Modal.destroyAll();
            }
        });
    }

    const onCancelOrder = (orderId) => {
        Modal.confirm({
            title: 'Подтвердите отмену заказа',
            content: 'Вы действительно хотите отменить заказ? Если заказ отменить, то все доступы по заказу будут удалены.',
            footer: (_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'pr-2'}>
                        <Button text={'Отмена'} onClick={() => {Modal.destroyAll()}}/>
                    </div>
                    <Button text={'Подтверждаю'} onClick={() => onCancelOrderConfirm(orderId)} type={'primary'}/>
                </div>
            ),
        });
    }
    const onCancelOrderConfirm = (orderId) => {
        RequestApi.get('private/order/' + orderId + '/cancel').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setIsReload(!isReload);
                Modal.destroyAll();
            }
        });
    }

    const onSetPayment = (orderId) => {
        setOrderPayment(orderId);
        setOpenPayment(true);
    }

    const onSetPaymentConfirm = () => {
        if (orderPayment && inputDatePayment) {
            RequestApi.post('private/order/' + orderPayment + '/payment', {
                dt: inputDatePayment,
                comment: inputCommentPayment
            }).then((data) => {
                if (data.status === RequestApi.STATUS_SUCCESS) {
                    setIsReload(!isReload);
                    setInputDatePayment('');
                    setInputCommentPayment('');
                    setOpenPayment(false);
                } else {
                    let errorMessages = data.error.messages;
                    if (data.error.fields.comment) {
                        errorMessages.push('Заполните поле комментарий');
                    }
                    apiNotification['error']({
                        message: 'Ошибка установки оплаты',
                        description: data.error.messages.join(' '),
                    });
                }
            });
        } else {
            apiNotification['error']({
                message: 'Ошибка установки оплаты',
                description: 'Укажите дату',
            });
        }
    }

    const onPaymentProcess = (orderId) => {
        window.location.href = config.host + '/order/payment/form/' + orderId;
        //navigate('/public/order/' + orderId);
    }

    const onPaymentInvoiceProcess = (orderId) => {
        //window.location.href = config.host + '/order/payment/invoice/' + orderId;
        window.open(config.host + '/order/payment/invoice/' + orderId, "_blank");
    }


    return <>
        {contextHolder}
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    { (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER'))
                        ? <span>Заказы пользователей</span>
                        : <span>Мои заказы</span>
                    }
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Список заказов
                </h2>
            </div>
            <Table loading={isLoading} expandable={{expandedRowRender}} onChange={handleTableChange} columns={columns} dataSource={dataSource} pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} pageSize={pageSize} showSizeChanger={true} onShowSizeChange={(current, size) => setPageSize(size)} onChange={onPaginate} total={total}/>
            </div>
        </div>
        <Modal
            title="Установить оплату"
            open={isOpenPayment} onOk={onSetPaymentConfirm} onCancel={() => setOpenPayment(false)}
            footer={(_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'w-6/12 pr-2'}>
                        <Button text={'Отмена'} onClick={() => setOpenPayment(false)}/>
                    </div>
                    <div className={'w-6/12'}>
                        <Button text={'Подтвердить'} onClick={() => onSetPaymentConfirm()} type={'primary'}/>
                    </div>
                </div>
            )}
        >
            <div className={'flex'}>
                <div className={'w-5/12 pr-2'}>
                    <DatePicker value={inputDatePayment ? dayjs(inputDatePayment, 'DD.MM.YYYY') : ''} showTime={{format: 'HH:mm'}} format={'DD.MM.YYYY HH:mm'} style={{width: '100%'}} onChange={(date, dateString) => setInputDatePayment(dateString)}/>
                </div>
                <div className={'w-7/12'}>
                    <InputAntd value={inputCommentPayment} onChange={(e) => setInputCommentPayment(e.target.value)} placeholder={'Введите комментарий'}/>
                </div>
            </div>
        </Modal>
    </>

}

export default OrdersPage;
